import api from './api'

const bookingService = {
  // Create booking
  createBooking: async (bookingData) => {
    const response = await api.post('/bookings', bookingData)
    return response.data
  },

  // Get user bookings
  getUserBookings: async () => {
    const response = await api.get('/bookings/user')
    return response.data
  },

  // Get booking by ID
  getBookingById: async (id) => {
    const response = await api.get(`/bookings/${id}`)
    return response.data
  },

  // Get all bookings (admin)
  getAllBookings: async (params = {}) => {
    const response = await api.get('/bookings', { params })
    return response.data
  },

  // Update booking status (admin)
  updateBookingStatus: async (id, statusData) => {
    const response = await api.put(`/bookings/${id}/status`, statusData)
    return response.data
  },

  // Calculate price
  calculatePrice: async (bookingData) => {
    const response = await api.post('/bookings/calculate-price', bookingData)
    return response.data
  },

  // Delete booking (admin)
  deleteBooking: async (id) => {
    const response = await api.delete(`/bookings/${id}`)
    return response.data
  },

  // Cancel booking (user)
  cancelBooking: async (id, data) => {
    const response = await api.put(`/bookings/${id}/cancel`, data)
    return response.data
  },

  // Cancel booking (admin)
  adminCancelBooking: async (id, reason) => {
    const response = await api.put(`/bookings/${id}/cancel-admin`, { reason })
    return response.data
  },

  // Download invoice PDF
  getInvoicePdf: async (id) => {
    const response = await api.get(`/bookings/${id}/invoice-pdf`, { responseType: 'blob' })
    return response.data
  },
}

export default bookingService
